import { lazy } from 'react'

export const SettingsUsersPage = lazy(() => import('../components/settings/SettingsUsersPage'))
export const SettingsIntegrationsPage = lazy(() => import('../components/settings/SettingsIntegrationsPage'))
export const TechnicalDocumentationPage = lazy(() => import('../components/docs/TechnicalDocumentationPage'))
export const BasecampProjectsHubPage = lazy(() => import('../components/basecamp/BasecampProjectsHubPage'))
export const BasecampKnowledgePage = lazy(() => import('../components/basecamp/BasecampKnowledgePage'))
export const AiAgentsHubPage = lazy(() => import('../components/ai/AiAgentsHubPage'))
export const AiAgentsLogsPage = lazy(() => import('../components/ai/AiAgentsLogsPage'))
export const AiCostMonitoringPage = lazy(() => import('../components/ai/AiCostMonitoringPage'))
export const OutlookHubPage = lazy(() => import('../components/outlook/OutlookHubPage'))
export const SharepointsPage = lazy(() => import('../components/sharepoint/SharepointsPage'))
export const OnenotesPage = lazy(() => import('../components/onenote/OnenotesPage'))
export const KnowledgeDashboard = lazy(() => import('../components/knowledge/KnowledgeDashboard'))
export const KnowledgeContent = lazy(() => import('../components/knowledge/KnowledgeContent'))
export const KnowledgeAccess = lazy(() => import('../components/knowledge/KnowledgeAccess'))
export const KnowledgeWiki = lazy(() => import('../components/knowledge/KnowledgeWiki'))
export const McpOverview = lazy(() => import('../components/mcp/McpOverview'))
export const McpKeys = lazy(() => import('../components/mcp/McpKeys'))
export const McpTools = lazy(() => import('../components/mcp/McpTools'))
export const McpLogs = lazy(() => import('../components/mcp/McpLogs'))
